"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Checks to see if this strings contains characters from right to left languages like arabic
var isRTLText = function isRTLText(text) {
  // This came from here: https://codepen.io/vsync/pen/rcwui
  var ltrChars = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF";
  var rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC";
  var rtlDirCheck = new RegExp("^[^".concat(ltrChars, "]*[").concat(rtlChars, "]"));
  return rtlDirCheck.test(text);
};

var _default = isRTLText;
exports["default"] = _default;